import { useRef, useState, useLayoutEffect } from "react";
import { cn } from "@/lib/utils";

// Scales its content down (never up) so everything fits the available
// space without scrolling or clipping. Ideal for a fixed kiosk screen.
export function AutoFit({ children, className }) {
  const outer = useRef(null);
  const inner = useRef(null);
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const measure = () => {
      const o = outer.current;
      const i = inner.current;
      if (!o || !i) return;
      const availH = o.clientHeight;
      const availW = o.clientWidth;
      const natH = i.scrollHeight;
      const natW = i.scrollWidth;
      if (!natH || !natW) return;
      const s = Math.min(1, availH / natH, availW / natW);
      const next = s > 0 && isFinite(s) ? s : 1;
      setScale((prev) => (Math.abs(prev - next) > 0.004 ? next : prev));
    };
    measure();
    const ro = new ResizeObserver(measure);
    if (outer.current) ro.observe(outer.current);
    if (inner.current) ro.observe(inner.current);
    window.addEventListener("resize", measure);
    window.addEventListener("orientationchange", measure);
    const t = setTimeout(measure, 300);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", measure);
      window.removeEventListener("orientationchange", measure);
      clearTimeout(t);
    };
  }, [children]);

  return (
    <div ref={outer} className={cn("flex h-full w-full justify-center overflow-hidden", className)}>
      <div ref={inner} style={{ transform: `scale(${scale})`, transformOrigin: "top center", width: "100%" }}>
        {children}
      </div>
    </div>
  );
}
